// import React, { useEffect, useState } from 'react';
// import { QRCodeCanvas } from "qrcode.react";


// function BulkUpload() {
//   const [products, setProducts] = useState([]);
//   const [qrCodes, setQrCodes] = useState({});

//   // Fetch products from the backend
//   useEffect(() => {
//     fetch('http://localhost:3000/products')
//       .then(res => res.json())
//       .then(data => setProducts(data))
//       .catch(err => console.error(err));
//   }, []);

//   // Generate QR codes for each product
//   const generateQRCode = (productId) => {
//     fetch(`http://localhost:3000/generate-qr/${productId}`)
//       .then(res => res.json())
//       .then(data => {
//         setQrCodes(prevState => ({
//           ...prevState,
//           [productId]: data.qrCodeUrl
//         }));
//       })
//       .catch(err => console.error(err));
//   };

//   return (
//     <div>
//       <h1>Product List</h1>
//       <ul>
//         {products.map(product => (
//           <li key={product.id}>
//             <h2>{product.name}</h2>
//             <p>{product.description}</p>
//             <button onClick={() => generateQRCode(product.id)}>
//               Generate QR Code
//             </button>
//             {qrCodes[product.id] && (
//               <div>
//                 <h3>QR Code:</h3>
//                 <QRCodeCanvas value={qrCodes[product.id]} />
//               </div>
//             )}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default BulkUpload;
import React, { useEffect, useState } from 'react';
import { QRCodeCanvas } from "qrcode.react";
import { fontGrid } from '@mui/material/styles/cssUtils';

function BulkUpload() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [products, setProducts] = useState([]);

  // Handle file selection
  const onFileChange = (e) => {
    setFile(e.target.files[0]);
  };


  const  userId =sessionStorage.getItem('userId')
  // Handle file upload
  const onFileUpload = () => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);

    fetch('https://qrapi.emedha.in/upload-excel', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.text())
      .then(data => {
        setMessage('File uploaded and data saved successfully');
        fetchProducts();  // Fetch the products after upload
      })
      .catch(error => {
        setMessage('Error uploading file');
      });
  };

  // Fetch the list of products from the backend
  const fetchProducts = () => {
    fetch(`https://qrapi.emedha.in/products?userId=${userId}`)
      .then(res => res.json())
      .then(data => {
        setProducts(data); // Set the list of products along with QR codes
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  };

  
  useEffect(()=>{
    fetchProducts()
  },[])

  return (
    <div style={styles.uploadContainer}>
      <h1 style={styles.header}>Bulk Product Upload</h1>
      <input
        type="file"
        onChange={onFileChange}
        style={styles.fileInput}
      />
      <button onClick={onFileUpload} style={styles.uploadButton}>Upload File</button>
      <p style={styles.message}>{message}</p>

      {products.length > 0 && (
        <div style={styles.qrCodesContainer}>
          <h2 style={styles.qrCodesHeader}>Generated QR Codes</h2>
          <div style={styles.qrCodes}>
            {products.map((product) => (
              <div key={product.id} style={styles.qrCodeItem}>
              
                <p style={styles.productId}>{product.name}</p>
                <img src={product.qr_code_url} alt="QR Code" style={styles.qrImage} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// Inline styles
const styles = {
  uploadContainer: {
    textAlign: 'center',
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    maxWidth: '800px',
    margin: '0 auto',
    backgroundColor: '#f9f9f9',
  },
  header: {
    marginBottom: '20px',
    fontSize:'30px',
    color:'#0F172A',

  },
  fileInput: {
    marginBottom: '15px',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  uploadButton: {
    backgroundColor: '#0d6efd',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.3s ease',
  },
  uploadButtonHover: {
    backgroundColor: '#45a049',
  },
  message: {
    fontSize: '18px',
    color: '#333',
    marginTop: '15px',
  },
  qrCodesContainer: {
    marginTop: '20px',
  },
  qrCodesHeader: {
    fontSize: '20px',
    marginBottom: '10px',
  },
  qrCodes: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: '15px',
    justifyItems: 'center',
  },
  qrCodeItem: {
    textAlign: 'center',
  },
  productId: {
    marginTop: '8px',
    fontWeight: 'bold',
  },
};

export default BulkUpload;
